import React from 'react';
import styled from 'styled-components';

const Loader = styled(({ ...rest }) => <div {...rest} />)`
    align-self: stretch;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;

    div {
        width: 100%;
        font-size: 34px;
        color: #ccc;
        text-align: center;
        margin-bottom: 21px;
    }

    svg path,
    svg rect {
        fill: #ccc;
    }
`;

const Loading = ({ textOverride }) => {
    return (
        <Loader>
            <div>{typeof textOverride === 'string' && textOverride.length ? `${textOverride}` : Loading}</div>
            <svg
                version="1.1"
                id="Layer_1"
                xmlns="http://www.w3.org/2000/svg"
                xmlnsXlink="http://www.w3.org/1999/xlink"
                x="0px"
                y="0px"
                width="72px"
                height="90px"
                viewBox="0 0 24 30"
                xmlSpace="preserve"
            >
                <rect x="0" y="0" width="4" height="10" fill="#333">
                    <animateTransform
                        attributeType="xml"
                        attributeName="transform"
                        type="translate"
                        values="0 0; 0 20; 0 0"
                        begin="0"
                        dur="0.6s"
                        repeatCount="indefinite"
                    />
                </rect>
                <rect x="10" y="0" width="4" height="10" fill="#333">
                    <animateTransform
                        attributeType="xml"
                        attributeName="transform"
                        type="translate"
                        values="0 0; 0 20; 0 0"
                        begin="0.2s"
                        dur="0.6s"
                        repeatCount="indefinite"
                    />
                </rect>
                <rect x="20" y="0" width="4" height="10" fill="#333">
                    <animateTransform
                        attributeType="xml"
                        attributeName="transform"
                        type="translate"
                        values="0 0; 0 20; 0 0"
                        begin="0.4s"
                        dur="0.6s"
                        repeatCount="indefinite"
                    />
                </rect>
            </svg>
        </Loader>
    );
};

export default Loading;
